<template>
  <div v-if="! projectCategoryTags" class="text-center pa-4" style="font-size: 18px">
    <i class="far fa-spinner fa-spin"></i>
  </div>
  <div v-else-if="! projectCategoryTags.length" class="text-medium-emphasis">{{ $t('MANAGE.CONFIG.NO_CATEGORY') }}</div>
  <v-table v-else dense class="manage-config-project-settings-categories">
    <tbody>
      <tr v-for="category in projectCategoryTags" :key="category">
        <td>{{ category }}</td>
        <td>
          <input :value="`#${getCategoryColor(category)}`" type="color" class="vcenter" @change="setCategoryColor(category, $event)">
          <v-btn-icon v-if="getCategoryColor(category) != str2color(category)" :title="$t('MANAGE.CONFIG.DEFAULT_COLOR')" size="x-small" class="ml-2"
                      @click="deleteCategoryColor(category)">
            <v-icon>far fa-undo-alt</v-icon>
          </v-btn-icon>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<style lang="scss">
  .manage-config-project-settings-categories {
    table {
      width: auto !important;
    }
    td {
      border-radius: 0 !important;
    }
  }
</style>

<script>
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    data() {
      return {
        categoryColors: {},
        projectCategoryTags: null,
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      computedBusinessConfigCategoryColor() {
        return this.usersAccessRightStore.businessConfig?.categoryColors || {};
      },
      getCategoryColor() { return this.usersAccessRightStore.config.getCategoryColor; },
      str2color() { return window.str2color; },
    },
    watch: {
      computedBusinessConfigCategoryColor: {
        handler(newVal) {
          this.categoryColors = { ...newVal };
        },
        immediate: true,
      },
    },
    created() {
      window.apiSrv.call('plannings/categories', 'index').then((response) => {
        this.projectCategoryTags = this.categories2tags(response.data?.categories || []).sort((a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1));
      });
    },
    methods: {
      categories2tags(categories) {
        const tags = new Set();
        categories.forEach((item) => {
          (item || '').split(',').forEach((subitem) => {
            const tag = subitem?.trim();
            if (tag) tags.add(tag);
          });
        });
        return [...tags];
      },
      setCategoryColor(category, { target: { value: color } }) {
        this.categoryColors[category] = color.replace('#', '');
        this.setParam('categoryColors', this.categoryColors);
      },
      deleteCategoryColor(category) {
        delete this.categoryColors[category];
        this.setParam('categoryColors', this.categoryColors);
      },
      setParam(prop, val) {
        this.usersAccessRightStore.updateBusinessConfig({ [prop]: val });
      },
    },
  };
</script>
